import { createContext, useContext, type ReactNode } from "react";
import {
  useSessionManager,
  type SessionManagerState,
} from "@/shared/hooks/useSessionManager";

type SessionContextValue = SessionManagerState;

const SessionContext = createContext<SessionContextValue | undefined>(undefined);

export function SessionProvider({ children }: { children: ReactNode }) {
  const sessionManager = useSessionManager();
  return (
    <SessionContext.Provider value={sessionManager}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession(): SessionContextValue {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
}
